// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.JZv3herB07trrpQuCUfW{z-index:2}`, "",{"version":3,"sources":["webpack://./src/form_components/select.module.scss"],"names":[],"mappings":"AAAA,yBACE,SAAA","sourcesContent":["div.menu {\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `JZv3herB07trrpQuCUfW`
};
export default ___CSS_LOADER_EXPORT___;
